import { render } from "./MarketIcon.vue?vue&type=template&id=2b86e720"
import script from "./MarketIcon.vue?vue&type=script&lang=js"
export * from "./MarketIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__